/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-unresolved */
import React, { useEffect } from 'react';
import { rafTimeoutInterval } from '@backpackjs/core-nextjs/utils';
import { store, StateProvider } from '@backpackjs/storefront';
import { parse } from 'telejson';

// This is new customizer bridge
import {
  renderSections,
  useCustomizerShell,
} from '@backpackjs/core-nextjs/customizerUtils';

import {
  Partytown,
  PageErrorBoundary,
  CustomizerModeScreen,
} from '../_components';

import sectionComponents from '../sections';
import storefrontSettingsSchema from '../settings';
import StorefrontLayout from '../layouts/Storefront';

import '../styles/storefront.css';

rafTimeoutInterval();

function StorefrontApp({
  Component,
  pageData,
  pageProps,
  router,
  storefrontSettings,
}) {
  const setRoute = store.recoil.useSetRecoilState(store.state.route);
  const setStorefrontSettings = store.recoil.useSetRecoilState(
    store.state.storefrontSettings
  );

  const config = parse(pageProps?.config || '{}');

  // update ROUTE_VIEW state
  // this is responsible for sending all the VIEW_X events
  useEffect(() => {
    setRoute(router.asPath);
  }, [router.asPath, setRoute]);

  // update the storefront settings in recoil store
  useEffect(() => {
    setStorefrontSettings(storefrontSettings);
  }, [storefrontSettings, setStorefrontSettings]);

  return (
    <>
      <Partytown {...config?.partytown} />

      <CustomizerModeScreen isPreview={pageProps.isPreview} />

      <StorefrontLayout
        ContentForLayout={Component}
        {...pageProps}
        config={config}
        renderSections={renderSections(
          {
            ...pageProps,
            page: pageData,
          },
          sectionComponents
        )}
      />
    </>
  );
}

function App(props) {
  const { Component, pageProps, router } = props;

  const { pageData, storefrontSettings } = useCustomizerShell({
    environment: pageProps.environment,
    isPreview: pageProps.isPreview,
    sectionComponents,
    staticProps: pageProps,
    storefrontSettingsSchema,
  });

  return (
    <PageErrorBoundary>
      <StateProvider
        pageData={pageData}
        pageProps={pageProps}
        route={router.asPath}
        storefrontSettings={storefrontSettings}
      >
        {React.cloneElement(
          <StorefrontApp />,
          {
            Component,
            pageData,
            pageProps,
            router,
            storefrontSettings,
          },
          null
        )}
      </StateProvider>
    </PageErrorBoundary>
  );
}

export default App;
